module.exports = __webpack_public_path__ + "img/blog.aebd07f5.jpg";